import React, { useState, useEffect } from "react";
import { IonPage, IonContent, IonAccordion, IonItem, IonLabel, IonList, IonAccordionGroup } from '@ionic/react';
import Footer from "../components/Footer";
import Header from "../components/Header";
import './FAQ.css';
import env from '../env.json'
import ReactGA from "react-ga4";
import axios from "axios";

// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//       page_location: '/pages/FAQ',
//       page_title: 'FAQ'
//   }
// };

// console.log('Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (page_view):', error);
// });



// ReactGA.send({ hitType: "pageview", page: "/pages/FAQ", page_title: "Preguntas frecuentes" });

const FAQ: React.FC = () => {

    const [faqs, setFaqs] = useState([{id: '', title: '', description: '', linkType: '', link: ''}]);

    const url = env.REACT_APP_URL;
    const token = localStorage.getItem('token');
    const header = {
        'Authorization': 'Bearer ' + token
    }



    const fillFaq = () => {
        let dataFaqs = localStorage.getItem('faqs');
        const faqs = JSON.parse(dataFaqs!)
        setFaqs(faqs);
    }

    const extraerUrl = (text: string) => {
        const list = text.split(' ')
        const len = list.length
        for (var i = 0; i < len; i++) {
            if (list[i].includes('https')) {
                return list[i]
            }
        }
    }

    const getFaqs = async () => {
        const instance = axios.create({
            baseURL: url,
            headers: header
        })

        await instance.get('/api/questions')
        .then(res => {
            localStorage.setItem('faqs', JSON.stringify(res.data.data))
        })
    }

    useEffect( () => {
        getFaqs();
        fillFaq();
    }, [])

    if(faqs[0].id == "") {
        return(
            <IonPage>
                <Header pageName="Preguntas frecuentes"/>
                <IonContent className='container'>
                    <div className="container justify-content-center no-encuestas">
                        <h3>No hay preguntas disponibles</h3>
                    </div>
                </IonContent>
                <Footer />
            </IonPage>
        );
    }

    else {
        return(
            <IonPage>
                <Header pageName="Preguntas frecuentes"/>
                <IonContent className='container'>
                    <IonAccordionGroup>
                        {   faqs[0].id != "" &&
                            faqs.map( faq => {
                                let urlFaq = extraerUrl(faq.description)
                                console.log('->', faq.linkType)
                                return (
                                    <IonAccordion key={faq.id}>
                                        <IonItem slot="header">
                                            <p>{faq.title}</p>
                                        </IonItem>
                                        <IonList slot="content" lines="inset">
                                            <IonItem>
                                                <p className="items">{faq.description}</p>                                                
                                            </IonItem>

                                            {/* {urlFaq != undefined ? <a href={urlFaq}>Ir al link</a> : ''} */}
                                            {faq.linkType == 'url' ? <a className="btn btn-actualizar" href={faq.link}>Visitar</a> : faq.linkType == 'mail' ? <a href={'mailto:' + faq.link}>Enviar correo a {faq.link}</a> : ''} 
                                        </IonList>
                                    </IonAccordion>
                                );
                            })
                        }
                    </IonAccordionGroup>
                </IonContent>
                <Footer />
            </IonPage>
        );
    }
}

export default FAQ;